/* article-line-sticky.js (v3.1 A/B並走版 2026-05-14)
   - LocalStorage で variant 固定 (A or B / 50:50)
   - pulse: 初回5秒後 + スクロール停止3秒後 (最大3サイクル/ページ)
   - close ボタン 24h 非表示
   - GA4 click イベント (article_handle / device / cta_variant / cta_element)
*/
(function () {
  var STORAGE_KEY = 'tbd_sticky_cta_dismissed_at';
  var VARIANT_KEY = 'tbd_sticky_cta_variant';
  var DISMISS_HOURS = 24;
  var els = document.querySelectorAll('[data-line-sticky-cta]');
  if (!els.length) return;

  // 24h 以内に閉じられていれば非表示
  var dismissedAt = localStorage.getItem(STORAGE_KEY);
  if (dismissedAt && (Date.now() - +dismissedAt) < DISMISS_HOURS * 3600 * 1000) {
    els.forEach(function (e) { e.style.display = 'none'; });
    return;
  }

  // A/B 振り分け (variant が決まっていなければ Math.random で50/50)
  var variant = localStorage.getItem(VARIANT_KEY);
  if (variant !== 'A' && variant !== 'B') {
    variant = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(VARIANT_KEY, variant);
  }
  els.forEach(function (e) { e.setAttribute('data-cta-variant', variant); });

  // close ボタン
  document.querySelectorAll('[data-line-sticky-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      els.forEach(function (e) { e.style.display = 'none'; });
      localStorage.setItem(STORAGE_KEY, Date.now());
    });
  });

  // pulse 制御: 初回5秒後 + スクロール停止3秒後、最大3サイクル
  var pulseCount = 0;
  var PULSE_MAX = 3;
  var pulseTargets = [];
  els.forEach(function (e) {
    var btn = e.querySelector('.tbd-sticky-cta-pc__btn, .tbd-sticky-cta-mobile__link');
    if (btn) pulseTargets.push(btn);
  });
  function firePulse() {
    if (pulseCount >= PULSE_MAX) return;
    pulseCount++;
    pulseTargets.forEach(function (b) {
      b.classList.remove('is-pulsing');
      // reflow for restart
      void b.offsetWidth;
      b.classList.add('is-pulsing');
      setTimeout(function () { b.classList.remove('is-pulsing'); }, 1500);
    });
  }
  // 初回5秒後
  setTimeout(firePulse, 5000);

  // スクロール停止3秒後 (stop = 500ms scrollなし → 3秒継続でfire)
  var scrollStopTimer = null;
  var idleTimer = null;
  window.addEventListener('scroll', function () {
    if (idleTimer) clearTimeout(idleTimer);
    if (scrollStopTimer) clearTimeout(scrollStopTimer);
    scrollStopTimer = setTimeout(function () {
      // 0.5秒スクロールなし=停止判定
      idleTimer = setTimeout(firePulse, 3000);
    }, 500);
  }, { passive: true });

  // GA4 click
  els.forEach(function (e) {
    e.addEventListener('click', function (ev) {
      var anchor = ev.target.closest('a');
      if (anchor && window.gtag) {
        var elementType = anchor.getAttribute('data-cta-element') || 'primary';
        gtag('event', 'article_sticky_cta_click', {
          article_handle: e.dataset.articleHandle || '',
          device: window.innerWidth >= 1280 ? 'pc' : 'mobile',
          cta_variant: variant,
          cta_element: elementType
        });
      }
    });
  });
})();
